import React from 'react';
import {NotificationItemProps} from "../../models";
import {Divider, Flex} from "antd";
import styled from "./NotificationItem.module.scss";
import { GoDotFill } from 'react-icons/go';
import {StyledCard, StyledDivider} from "./NotificationItem.styled";
import { updateNotificationStatus} from "../../actions/Notification.action";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {useNavigate} from "react-router-dom";

const NotificationItem = ({data,index ,updateNotificationStatus,onUpdateHandle}: NotificationItemProps) => {
 const navigate = useNavigate();
    const _updateNotificationStatus = () => {
        updateNotificationStatus(data?.id)
            .then((res: any) => {
                if (res.payload != undefined) {
                    navigate("/"+data?.url);
                    onUpdateHandle()
                }
            })
            .catch((e: any) => {
            });
    };
    return (
        <StyledCard onClick={() => _updateNotificationStatus()}>
            <Flex vertical gap={"small"} >
                {index > 0 && <StyledDivider/>}
                <Flex justify={"space-between"}>
                    <span className={data?.seenAt == null ? styled.activeTitle : styled.title}>{data?.title}</span>
                    {data?.seenAt == null && <GoDotFill className={styled.icon}/>}

                </Flex>
                <span className={data?.seenAt == null ? styled.activeDescription :styled.description}>{data?.body}</span>
            </Flex>
        </StyledCard>
    );
};

export default connect(null, {updateNotificationStatus})(
    withRouter(NotificationItem)
);